import { render } from "./BiomAten.vue?vue&type=template&id=c863854c&scoped=true"
import script from "./BiomAten.vue?vue&type=script&lang=js"
export * from "./BiomAten.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=c863854c&scoped=true&lang=css"
import "@/assets/css/tabla_estilizada.css?vue&type=style&index=1&id=c863854c&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=2&id=c863854c&scoped=true&lang=css"
import "./BiomAten.vue?vue&type=style&index=3&id=c863854c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c863854c"]])

export default __exports__